<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

function showQuestions() {
  router.push('/co2quiz');
}
function showValues() {
  router.push('/co2quiz/values');
}
function showAverages() {
  router.push('/co2quiz/averages');
}

const items = computed(() => {
  if (route.path === '/co2quiz') {
    return ['CO₂ Quiz', 'Questions'];
  } else if (route.path === '/co2quiz/values') {
    return [
      {
        title: 'CO₂ Quiz',
        href: '/co2quiz',
      },
      'Values',
    ];
  }
  return [
    {
      title: 'CO₂ Quiz',
      href: '/co2quiz',
    },
    'Averages',
  ];
});
</script>
<template>
  <v-app-bar app>
    <v-breadcrumbs :items="items" />
    <v-btn
      flat
      v-if="route.path !== '/co2quiz'"
      color="info"
      @click="showQuestions"
      >Questions</v-btn
    >
    <v-btn
      flat
      v-if="route.path !== '/co2quiz/values'"
      color="info"
      @click="showValues"
      >Values</v-btn
    >
    <v-btn
      flat
      v-if="route.path !== '/co2quiz/averages'"
      color="info"
      @click="showAverages"
      >Averages</v-btn
    >
  </v-app-bar>
</template>
<style>
.v-toolbar {
  z-index: 100 !important;
}
</style>
